export default __webpack_public_path__ + "static/802-3db3506079c32897f5bd76d643536092.gif";